/* @flow */
const prefix = str => `station/insights/${str}`;

export const FETCH_DASHBOARD = prefix('FETCH_DASHBOARD');

export const REGISTER_ACTIVITY = prefix('REGISTER_ACTIVITY');

export const SAVE_DATE_RANGE = prefix('SAVE_DATE_RANGE');
export const SET_DEFAULT_ENCLAVE = prefix('SET_DEFAULT_ENCLAVE');
export const SAVE_DEFAULT_ENCLAVE = prefix('SAVE_DEFAULT_ENCLAVE');

export const PAGINATE = prefix('PAGINATE');
export const PAGINATE_SUCCESS = prefix('PAGINATE_SUCCESS');
export const PAGINATE_FAILURE = prefix('PAGINATE_FAILURE');

export const FETCH_TIME_RANGE = prefix('FETCH_TIME_RANGE');
export const FETCH_TIME_RANGE_SUCCESS = prefix('FETCH_TIME_RANGE_SUCCESS');
export const FETCH_TIME_RANGE_FAILURE = prefix('FETCH_TIME_RANGE_FAILURE');

export const SET_DATE_OPTIONS = prefix('SET_DATE_OPTIONS');
export const APPLY_OPTIONS = prefix('APPLY_OPTIONS');

export const SELECT_ENCLAVE = prefix('SELECT_ENCLAVE');
export const SET_ENCLAVE_MENU = prefix('SET_ENCLAVE_MENU');
export const SET_VIEW_OPTIONS = prefix('SET_VIEW_OPTIONS');



// WEBPACK FOOTER //
// ./src/app/modules/insights/action-types.js